import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Dialog from 'material-ui/Dialog'
import YouTube from 'react-youtube'
import doctorsStore from '../stores/doctors'

class dialogObj extends Component {
  handleClose = () => {
    doctorsStore.open = false
  };

  _onReady(event) {
    event.target.playVideo();
  }

  render() {
    const opts = {
      width: '100%',
      playerVars: {
        autoplay: 1
      }
    };

    return (
      <div>
        <Dialog
          open={doctorsStore.open}
          repositionOnUpdate={false}
          autoDetectWindowHeight={false}
          modal={false}
          contentStyle={{ width: '90%' }}
          bodyStyle={{ padding: '0' }}
          style={{ paddingTop: '0' }}
          onRequestClose={this.handleClose}
        >
          <YouTube
            videoId="Ni_lx_BZpuE"
            opts={opts}
            onReady={this._onReady}
          />
        </Dialog>
      </div>
    );
  }
}

export default observer(dialogObj)



// WEBPACK FOOTER //
// ./src/components/Dialog.js